// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__34oXV","upload":"Small_upload__WIT-0","imageWrap":"Small_imageWrap__HwWFz","removeBtn":"Small_removeBtn__3Mea7"};